import {
  cpnFormatter,
  formatModifiedBy,
  hnoFormatter,
  translateToLocalDate,
} from "utils/helpers";

export type AliLog = {
  idx: number;
  msag_id: number;
  orig_msag_id: number | null;
  sop_id: number | null;
  FOC: string;
  CPN: string;
  HNP: string | null;
  HNO: string;
  HNE: string | null;
  HNS: string;
  PRD: string | null;
  STN: string;
  STS: string | null;
  POD: string | null;
  MCN: string;
  STA: string;
  LOC: string;
  NAM: string;
  CLS: string;
  TYS: string;
  Exchange: string;
  lecESN: string;
  MainNPA: string;
  MainNumber: string;
  OrderNumber: string;
  ExtractDate: string;
  lecCOI: string;
  CPF: string;
  SourceID: string | null;
  lecZipCode: string;
  lecZipExtension: string;
  GeneralUse: string | null;
  CustomerCode: string | null;
  Comments: string;
  lecLON: string;
  lecLAT: string;
  lecELV: string;
  CellID: string | null;
  SectorID: string | null;
  TARCode: string | null;
  Reserved1: string | null;
  AltNumber: string | null;
  ExpandedExtractDate: string;
  NENAReserved: string;
  DataProviderID: string;
  Reserved2: string;
  routingNature: string;
  privateCit: boolean;
  dd: number;
  esuri: string;
  inESN: string;
  ALIsteering: string;
  FDAY: string;
  GDAY: string;
  Community: string | null;
  COI: string | null;
  ZIP: string | null;
  LON: string;
  LAT: string;
  ELV: string;
  FIR: string;
  EMS: string;
  LAW: string;
  RA1: string;
  RA2: string | null;
  RA3: string | null;
  dCode: string;
  created: string;
  created_by: string;
  last_modified: string;
  modified_by: string;
  web_login: string;
  ali_tmp_idx: number | null;
  job_id: number | null;
  action: string;
  change_time: string;
  changed_by: string;
  error?: string;
  file?: string;
};

export const remove = (cell, formatterParams, onRendered) => {
  return `<calcite-icon id="trashIcon" icon="trash" scale="s"></calcite-icon>`;
};

export const options = (cell, formatterParams, onRendered) => {
  let id = cell.getData().idx;
  return `
      <a href="/ali-logs/view/${id}" title="View ALI Log">
        <calcite-icon id="viewLog-${id}" icon="view-visible" scale="s"></calcite-icon>
      </a>
    `;
};

export function getAliLogsColumns() {
  const aliLogsColumns: ColumnDefinition[] = [
    {
      title: "Telephone Number",
      field: "CPN",
      formatter: cpnFormatter,
      headerFilter: false,
      headerFilterLiveFilter: false,
    },
    {
      title: "FOC",
      field: "FOC",
      headerFilter: "input",
      headerFilterLiveFilter: false,
    },
    {
      title: "Last Changed",
      field: "last_modified",
      mutator: translateToLocalDate,
      headerFilter: "input",
      headerFilterLiveFilter: false,
    },
    {
      title: "Changed By",
      field: "modified_by",
      formatter: (cell) => formatModifiedBy(cell.getData()),
      headerFilter: "input",
      headerFilterLiveFilter: false,
    },
    {
      title: "SOP",
      field: "sop_id",
      headerFilter: "input",
      headerFilterLiveFilter: false,
    },
    {
      title: "NENA ID",
      field: "CPF",
      headerFilter: "input",
      headerFilterLiveFilter: false,
    },
    {
      title: "House Number",
      field: "HNO",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      formatter: hnoFormatter,
    },
    {
      title: "House Number Suffix",
      field: "HNS",
      headerFilter: "input",
      headerFilterLiveFilter: false,
    },
    {
      title: "Prefix Directional",
      field: "PRD",
      headerFilter: "input",
      headerFilterLiveFilter: false,
    },
    {
      title: "Street Name",
      field: "STN",
      headerFilter: "input",
      headerFilterLiveFilter: false,
    },
    {
      title: "Street Suffix",
      field: "STS",
      headerFilter: "input",
      headerFilterLiveFilter: false,
    },
    {
      title: "Post Directional",
      field: "POD",
      headerFilter: "input",
      headerFilterLiveFilter: false,
    },
    {
      title: "Msag Community Name",
      field: "MCN",
      headerFilter: "input",
      headerFilterLiveFilter: false,
    },
    {
      title: "State",
      field: "STA",
      headerFilter: "input",
      headerFilterLiveFilter: false,
    },
    {
      title: "Location",
      field: "LOC",
      headerFilter: "input",
      headerFilterLiveFilter: false,
    },
    {
      title: "Action",
      field: "action",
      headerFilter: "input",
      headerFilterLiveFilter: false,
    },
    {
      title: "Customer Name",
      field: "NAM",
      headerFilter: "input",
      headerFilterLiveFilter: false,
    },
    {
      title: "Class of Service",
      field: "CLS",
      headerFilter: "input",
      headerFilterLiveFilter: false,
    },
    {
      title: "Type of Service",
      field: "TYS",
      headerFilter: "input",
      headerFilterLiveFilter: false,
    },
    {
      title: "Exchange",
      field: "Exchange",
      headerFilter: "input",
      headerFilterLiveFilter: false,
    },
    {
      title: "ESN",
      field: "lecESN",
      headerFilter: "input",
      headerFilterLiveFilter: false,
    },
    {
      title: "Area Code",
      field: "MainNPA",
      headerFilter: "input",
      headerFilterLiveFilter: false,
    },
    {
      title: "Main Number",
      field: "MainNumber",
      headerFilter: "input",
      headerFilterLiveFilter: false,
    },
    {
      title: "Extract Date",
      field: "ExtractDate",
      headerFilter: "input",
      headerFilterLiveFilter: false,
    },
    {
      title: "County ID",
      field: "lecCOI",
      headerFilter: "input",
      headerFilterLiveFilter: false,
    },
    {
      title: "Source ID",
      field: "SourceID",
      headerFilter: "input",
      headerFilterLiveFilter: false,
    },
    {
      title: "Reserved 1",
      field: "Reserved1",
      headerFilter: "input",
      headerFilterLiveFilter: false,
    },
  ];

  // if(hasEditPermission) {
  //   aliLogsColumns.unshift({
  //     title: "",
  //     formatter: remove,
  //     width: 50,
  //     minWidth: 50,
  //     hozAlign: "center",
  //     headerSort: false,
  //   })
  // }

  return aliLogsColumns;
}
